import { Button } from "./Button";
import { Trash2 } from "lucide-react";

const TableDeleteButton = ({ onClickHandler }) => {
  return (
    <Button variant="ghost" size="icon" onClick={onClickHandler}>
      <Trash2 className="w-4 h-4" />
    </Button>
  );
};

export default TableDeleteButton;
